module.exports = __webpack_public_path__ + "static/media/avatar.730f89a4.png";